import moment from "moment";
import { useReducer } from "react";
import ProductContext, { internalState } from "./context";
import reducer from "./reducer";
import { execute } from "../../utils/helpers/execute";
import EndPoints from "../../services/end-points";
import {
  IAddQuantity,
  ICreateProduct, IdAccounting, IImportExcelProduct,
  IImportExcelProductStore,
  IManageProductStore,
  IMatchQuantity,
  IUpdateProduct,
} from "../../models/product/request";
import { IProduct } from "../../models/product/response";
import { IProductQuery } from "../../models/product/query";
export interface IProps {
  children: React.ReactNode;
}
const ProductContextProvider: React.FC<IProps> = (props) => {
  const [state, dispatch] = useReducer(reducer, internalState);
  const getData = async () => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });

        const { data } = await EndPoints.product.getAllProducts(state.query);

        dispatch({ type: "SET_LIST", payload: { list: data } });
      },
      fallback: () => { },
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "list" } });
      },
      throwException: false,
    });
  };

  const getQuantities = async (id:number) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "quantities" } });

        const { data } = await EndPoints.product.getQuantities(id);

        dispatch({ type: "SET_QUANTITIES", payload: { quantities: data } });
      },
      fallback: () => { },
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "quantities" } });
      },
      throwException: false,
    });
  };

  const getDetails = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });

        const { data } = await EndPoints.product.getProduct(id);
        dispatch({ type: "SET_DETAILS", payload: { details: data } });
      },
      fallback: (error) => { },
      finallyCallback: () => {
        dispatch({ type: "LOADING", payload: { loading: "details" } });
      },
      throwException: false,
    });
  };

  const setDetails = async (data?: IProduct) => {
    dispatch({ type: "SET_DETAILS", payload: { details: data } });
  };

  const createProduct = async (request: ICreateProduct) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });

        await EndPoints.product.createProduct(request);
        getData();
      },
      fallback: (error) => { },
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };
  const setIdAccounting = async (id: number, request: IdAccounting) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "setIdAccounting" },
        });

        await EndPoints.product.setIdAccounting(id, request);
      },
      fallback: () => { },
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "setIdAccounting" },
        });
      },
      throwException: true,
    });
  };
  const addQuantity = async (id: number, request: IAddQuantity) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "addQuantity" },
        });

        await EndPoints.product.addQuantity(id, request);
      },
      fallback: () => { },
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "addQuantity" },
        });
      },
      throwException: true,
    });
  };
  const matchQuantity = async (id: number, request: IMatchQuantity) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "matchQuantity" },
        });

        await EndPoints.product.matchQuantity(id, request);
      },
      fallback: (error) => { },
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "matchQuantity" },
        });
      },
      throwException: true,
    });
  };

  const manageProductStore = async (request: IManageProductStore) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "manage" },
        });

        await EndPoints.product.manageProductStore(request);
        getData();
      },
      fallback: (error) => { },
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "manage" },
        });
      },
      throwException: true,
    });
  };
  const importExcelProductStore = async (request: IImportExcelProductStore) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "manage" },
        });

        await EndPoints.product.importFromExcelProductStore(request);
        getData();
      },
      fallback: (error) => { },
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "manage" },
        });
      },
      throwException: true,
    });
  };

  const importExcelProducts = async (request: IImportExcelProduct) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "manage" },
        });

        await EndPoints.product.importFromExcelProduct(request);
        getData();
      },
      fallback: (error) => { },
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "manage" },
        });
      },
      throwException: true,
    });
  };

  const circulateProduct = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
        await EndPoints.product.circulateProduct(id);

        getData();
      },
      fallback: (error) => { },
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
      },
      throwException: true,
    });
  };

  const updateProduct = async (id: number, request: IUpdateProduct) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
        await EndPoints.product.updateProduct(id, request);

        getData();
      },
      fallback: (error) => { },
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "update" },
        });
      },
      throwException: true,
    });
  };

  const deleteProduct = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });

        await EndPoints.product.deleteProduct(id);

        getData();
      },
      fallback: (error) => { },
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "delete" },
        });
      },
      throwException: true,
    });
  };

  const setSearch = (search?: string) => {
    dispatch({ type: "SET_SEARCH", payload: { search } });
  };

  const setQuery = (query: IProductQuery) => {
    dispatch({ type: "SET_QUERY", payload: { query } });
  };
  const exportExcel = async (request: any) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
        const data = await EndPoints.product.exportExcel(
          request,
          state.query
        );

        const url = window.URL.createObjectURL(new Blob([data.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Products-${moment().format("yyyy-MM-d")}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      },
      fallback: (error) => { },
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };

  const downloadFileExcel = async (id: number) => {
    await execute({
      callback: async () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
        const { data } = await EndPoints.media.getMedia(id);

        const link = document.createElement("a");
        link.href = data.url.replace('http://', 'https://');
        link.download = `product-${moment().format("yyyy-MM-d")}.xlsx`;
        link.click();
      },
      fallback: (error) => { },
      finallyCallback: () => {
        dispatch({
          type: "LOADING",
          payload: { loading: "create" },
        });
      },
      throwException: true,
    });
  };

  return (
    <ProductContext.Provider
      value={{
        ...state,
        actions: {
          getData,
          getQuantities,
          getDetails,
          setDetails,
          importExcelProductStore,
          importExcelProducts,
          circulateProduct,
          setIdAccounting,
          addQuantity,
          matchQuantity,
          createProduct,
          manageProductStore,
          updateProduct,
          deleteProduct,
          exportExcel,
          downloadFileExcel,
          setSearch,
          setQuery,
        },
      }}
    >
      {props.children}
    </ProductContext.Provider>
  );
};

export default ProductContextProvider;
